const profileSetup = {
  introduction: {
    title: 'Willkommen bei',
    message:
      'In diesem Formular legst du schnell und unkompliziert dein Firmen-Profil an, damit wir euch unseren Talenten Optimal präsentieren könnt.',
  },
  complete: {
    message: 'You have successfully setup your company profile!',
  },
  fields: {
    sectionTitle: 'Unternehmensprofil',
    companyName: {
      label: 'Firmenname',
      description_html:
        'Unter welchen Namen sollen wir den Talenten dein Unternehmen präsentieren?',
    },
    companyIndustry: {
      label: 'Unternehmensbranche',
      description_html: 'In welcher Branche ist dein Unternehmen aktiv?',
    },
    businessModel: {
      label: 'Geschäftsmodell',
      description_html:
        'Was ist das primäre Geschäftsmodell deines Unternehmens?',
    },
    companyDescriptionShort: {
      label: 'Unternehmensaufgabe',
      description_html:
        'Bitte beschreibe in maximal 3 Absätzen so einfach und klar wie möglich was dein Unternehmen macht.',
    },
    companyCulture: {
      label: 'Firmenkultur',
      description_html:
        'Bitte beschreibe in Stichpunkten eure Arbeitsweise sowie eure Firmenkultur mit mindestens 3 Unternehmenswerten.<br /> ' +
        '<small>Merkmale der Kultur sind z.B ' +
        '<ul> <li>Die Gestaltung der Hierarchieebenen ' +
        '<li>Die generelle Arbeitsweise - Regelmäßige Teamevents (Kochen, After-Work Veranstaltungen, etc.) ' +
        '<li>Tischtennis, Chill-Area, gut ausgestattete Küche ' +
        '<li>Regelmäßige Workshops und Weiterbildungsmaßnahmen ' +
        '<li>Das Mitbringen von Haustieren ' +
        '</ul></small>',
    },
    companyBenefits: {
      label: 'Benefits',
      description_html:
        'Welche weiteren Events/Benefits bietet ihr Mitarbeitern (abseits des Gehalts)?<br /> Weitere Benefits sind z.B. ' +
        '<small><ul> <li>Kostenlose Snacks oder Getränke ' +
        '<li>Firmenwagen (kann er auch privat genutzt werden?) ' +
        '<li>Weihnachtsgeld </ul></small>',
    },
    onboarding: {
      label: 'Wie sieht euer Onboarding aus?',
      description_html:
        'Gibt es z.B. ein generelles Buddy-System oder eine feste Roadmap an Themen, die immer bearbeitet wird?',
    },
    techStack: {
      label: 'Wie sieht euer Tech-Stack aus?',
      description_html:
        'Welche Tools werden in Eurem Sales-Team (z.B. CRM, Lead-gen Programme) verwendet?',
    },
    quotaErfolg: {
      label: 'Wie viele Sales-Mitarbeiter erreichen ihre Quota?',
      description_html:
        'Wie viele der aktuellen Mitarbeiter erreichen die im Sales-Team gestellten Ziele?',
    },
    companyWebsite: {
      label: 'Website URL',
      description_html: 'Bitte gebe die Website deines Unternehmens an.',
    },
    logo: {
      label: 'Logo',
      description_html:
        'Bitte lade das Logo deines Unternehmens hoch, um deiner Ausschreibung einen persönlichen Touch zu geben. <br /> Je höher die Auflösung, desto besser',
      inputText: 'Bilddatei auswählen',
      helpText_html: '.jpg, .png oder .svg, maximal 5MB',
    },
    respondeeEmail: {
      label: 'E-Mail-Adresse',
      description_html:
        'Bitte gebe uns deine E-mail Adresse, damit wir dich kontaktieren können. (Falls abweichend von deiner Login-Adresse)',
    },
    privacyPolicy: {
      label: 'Datenschutzerklärung und Allgemeine Geschäftsbedingungen',
      description_html:
        'Durch das Ausfüllen und Absenden dieses Formulars bestätigst du, die Datenschutzrichtlinien von HYRE gelesen zu haben und diesen zuzustimmen.',
      helpText_html:
        'Ich habe <a class="visited:text-primary-500 underline" href="https://hyretalents.com/privacy-policy" target="_blank"> die Datenschutzerklärung</a>' +
        ' und <a class="visited:text-primary-500 underline"  href="https://hyretalents.com/terms-and-conditions" target="_blank">die Allgemeine Geschäftsbedingungen</a> von HYRE gelesen, und ich stimme zu.',
    },
    submit: {
      cta: 'Profil vervollständigen',
    },
    paymentMethod: {
      label: 'Mit welcher Methode wollt ihr Zahlungen tätigen?',
      description_html:
        'Wir melden uns im Anschluss mit allen Details zum Aufsetzen der Zahlvorgänge',
    },
    paymentsContactPerson: {
      label: 'Wen kontaktieren wir bei euch am besten zum Thema Zahlungen?',
      description_html:
        'Gib am besten den Namen der Person und den Titel/ die Abteilung an.' +
        '<br /><br />' +
        'Falls Du es bist, schreib einfach "ich"',
    },
    paymentsContactPersonEmail: {
      label:
        'Unter welcher Email erreichen wir die oben gennante Person/ Abteilung am besten?',
      description_html: '',
    },
    paymentsDecideLaterContactPerson: {
      label:
        'Wen kontaktieren wir bei euch am besten, um eine Zahlungsmethode auszumachen?',
      description_html:
        'Gib am besten den Namen der Person und den Titel/ die Abteilung an.',
    },
    paymentsDecideLaterContactPersonEmail: {
      label:
        'Unter welcher Email erreichen wir die oben gennante Person/ Abteilung am besten?',
      description_html: '',
    },
    paymentsDecideLaterComment: {
      label:
        'Hast du noch irgendwelche Kommentare zur Zahlungsmethode oder euerem dafür passenden Kontakt?',
      description_html: '',
    },
  },
}

const positionSetup = {
  sections: {
    basicInfo: {
      title: 'Basic info',
      nameShort: 'Basic Info',
    },
    framework: {
      title: 'Rahmenbedingungen der Stelle',
      nameShort: 'Rahmenbedingungen',
    },
    salesExperience: {
      title: 'Saleserfahrung',
      nameShort: 'Erfahrung',
    },
    soldProducts: {
      title: 'Verkaufte Produkte',
      nameShort: 'Produkte',
    },
    customerProfile: {
      title: 'Kunden-Profil',
      nameShort: 'Profil',
    },
    otherRequirements: {
      title: 'Andere Anforderungen',
      nameShort: 'Andere',
    },
    contactPerson: {
      title: 'Ansprechpartner',
      nameShort: 'Ansprechpartner',
    },
    finish: {
      nameShort: 'Senden',
    },
  },
  fields: {
    jobTitle: {
      label: 'Wie heißt die Stelle?',
      description_html: '',
    },
    jobAdType: {
      label: 'Vorgegebene Stellenanzeige',
      description_html:
        'Falls du bereits eine Jobanzeige hast, kannst du diese als zusätzliche Info hochladen.',
    },
    JobDescriptionUploadUrl: {
      buttonText: 'PDF-Datei auswählen',
    },
    salary: {
      label: 'Was ist das jährliche Fixgehalt der Stelle?',
      description_html: '',
    },
    bonus: {
      label: 'Wie hoch ist der Bonus bei dieser Stelle?',
      description_html: '',
    },
    bonusCapped: {
      label: 'Gibt es bei dem Bonus eine Maximalbegrenzung?',
      description_html: '',
    },
    salaryComments: {
      label: 'Welche weiteren Gehaltsaspekte sind zu beachten?',
      description_html: '',
      placeholder:
        '- Fixum je nach bisheriger Erfahrung\n' +
        '- Bonuszahlungen fallen für jedes erfolgreich vermittelte Talent an\n' +
        '  - Je nach Gehalt der Talente sind dies €200 - €1500\n' +
        '- Zusätzliche werden dir Unternehmensanteile im Wert von mehreren Tausend € ausgestellt, um dich am langfristigen Erfolg teilhaben zu lassen',
    },
    locations: {
      label: 'Wo ist die Stelle angesiedelt?',
      description_html: '',
    },
    homeOfficeDetails: {
      label: 'Remote-Arbeit',
      description_html: `Welche Regelungen gibt es zu Home Office bzw. Remote-Arbeit?<br />
                    <small>
                      Insbesondere wie viele Tage die Woche/ Monat normalerweise remote gearbeitet werden
                      kann und ob es Limits dazu gibt, von wo aus gearbeitet werden kann (selbe Stadt/ selbes Land/ selbe Zeitzone)
                    </small>`,
      placeholder:
        '- Hybrides Modell\n' +
        '  - 2 festen Tagen im Office\n' +
        '  - 2 der 3 verbleibenden nach freier Wahl im Homeoffice\n' +
        '- Nach der Probezeit, die Möglichkeit mehrere Wochen im Jahr aus dem Ausland zu arbeiten',
    },
    contractTerm: {
      label: 'Vertragslaufzeit',
      description_html: 'Um welche Vertragsart handelt es sich?',
    },
    contractDetails: {
      label: 'Infos zur Befristung',
      description_html:
        'Gibt es weitere Details der Befristung?<br/><small>Insbesondere die Dauer und die Faktoren, die über eine Verlängerung bestimmen.</small>',
      placeholder: '',
    },
    opportunityType: {
      label: 'Vertragsart',
      description_html: '',
    },
    opportunityTypeDetails: {
      label: 'Weitere Infos zum Vertrag',
      description_html:
        'Gibt es weitere Details zum Vertrag?<br/><small>Insbesondere zu den Konditionen einer Befristung oder den Regelungen des Freiberuflervertrags.</small>',
      placeholder: '',
    },
    latestStartDate: {
      label: 'Start-Datum',
      description_html: 'Bis wann muss die Stelle spätestens besetzt sein?',
    },
    startDateComments: {
      label: 'Infos zum Start-Datum',
      description_html:
        'Gibt es zum Start-Datum weitere wichtige Informationen? <br /><small>z.B. die Stelle wird rollierend besetzt, weswegen Talente immer anfangen können</small>',
      placeholder:
        'Wir stellen rollierend ein und wachsen stark, bewirb dich also jederzeit',
    },
    numberOfOpenPositions: {
      label: 'Offene Stellen',
      description_html:
        'Falls diese Stelle mehrfach besetzt werden soll, teile uns die Anzahl und eventuelle kleine Unterschiede z.B. beim Standort mit. ',
      placeholder: '',
    },
    positionSummary: {
      label: 'Zusammenfassung',
      description_html:
        'Bitte fasse die Stelle so einfach und klar wie möglich in maximal 3 Sätzen zusammen.',
      placeholder:
        '- Du stehst telefonisch in engem Kontakt mit unseren Talenten und entscheidest eigenständig, wer qualifiziert genug ist um in unseren Talent Pool aufgenommen zu werden\n' +
        '- Anschliessend berätst du unsere Talente, hilfst ihnen den passenden Job zu identifizieren und sich auf die Interviews vorzubereiten.\n' +
        '- Gleichzeitig wirst Du daran beteiligt sein, den dahinterstehenden Prozess immer weiter zu verbessern und zu automatisieren, sodass wir immer mehr Talente unterstützen können\n' +
        '- Zusätzlich wirst Du daran arbeiten, die Bedürfnisse und Wünsche unserer Talente immer besser zu verstehen, damit das Produkt-Team die richtigen Features entwickeln kann.',
    },
    personalDevelopment: {
      label: 'Persönliche Entwicklung',
      description_html:
        'Bitte beschreibe die fachliche und persönliche Entwicklung, die Kandidaten in der Stelle erwarten können' +
        ' (z.B. indem sie sich bei der Arbeit bestimmte Fähigkeiten aneignen oder Erfahrungen machen, die sie im ' +
        'weiteren Karriereweg deutlich voranbringen werden).',
      placeholder:
        '- Lernen, mit jedem vor Ort und telefonisch offen zu kommunizieren, um sich schnell und effektiv in die Bedürfnisse des Gegenübers einzuarbeiten\n' +
        '- Ein tiefes Verständnis für Kundenbedürfnisse und SaaS-Produkte entwickeln\n' +
        '- Schnell und effektiv mit Ablehnung umgehen',
    },
    salesExperienceWeight: {
      label:
        'Wie sehr sollen wir deine Angaben bei den nachfolgenden Fragen zur bisherigen Saleserfahrung in unserem Algorithmus gewichten? ',
      description_html:
        'Umso höher deine Angabe, desto mehr werden die Angaben relativ zu den anderen Bereichen gewichtet',
    },
    minimumSalesExperience: {
      label: 'Minimum Saleserfahrung',
      description_html:
        'Wie viel verkaufsrelevante Erfahrung ist für die Stelle mindestens erforderlich?',
    },
    salesRoleType: {
      label: 'Rolle',
      description_html:
        'Um welche Salesrolle(n) handelt es sich bei der Stelle im Kern?',
    },
    roleContents: {
      label: 'Kerntätigkeit(en)',
      description_html: 'Welche Kerntätigkeit(en) sind Teil der Stelle?',
    },
    requiredCoreTasks: {
      label: 'Erforderliche Tätigkeiten',
      description_html:
        'Welche Kerntätigkeit(en) müssen Talente bereits ausgeführt haben, um relevant zu sein?',
    },
    leadGenRelativeImportance: {
      label:
        'Wie wichtig ist Lead Generierung relativ zu den anderen Kerntätigkeiten?',
      description_html:
        'Beispiel: Die Stelle beinhaltet Lead Generierung und Lead Konvertierung, welche beide gleich wichtig sind, <br />' +
        '--> Bei beiden 50% auswählen',
    },
    requiredLeadGenExperience: {
      label:
        'Wie viel Erfahrung sollten Talente bei der Lead Generierung haben?',
      description_html: '',
    },
    leadConversionRelativeImportance: {
      label:
        'Wie wichtig ist Lead Konvertierung relativ zu den anderen Kerntätigkeiten?',
      description_html:
        'Beispiel: Die Stelle beinhaltet Lead Konvertierung und Lead Generierung, welche beide gleich wichtig sind, <br />' +
        '--> Bei beiden 50% auswählen ',
    },
    requiredLeadConversionExperience: {
      label:
        'Wie viel Erfahrung sollten Talente bei der Lead Konvertierung haben?',
      description_html: '',
    },
    accountManagementRelativeImportance: {
      label:
        'Wie wichtig ist Kundenbetreuung/ dem Upselling relativ zu den anderen Kerntätigkeiten?',
      description_html:
        'Beispiel: Die Stelle beinhaltet Kundenbetreuung und Lead Generierung, welche beide gleich wichtig sind, <br />' +
        '--> Bei beiden 50% auswählen ',
    },
    requiredAccountManagementExperience: {
      label:
        'Wie viel Erfahrung sollten Talente bei der Kundenbetreuung/ dem upselling haben?',
      description_html: '',
    },
    managementRelativeImportance: {
      label:
        'Wie wichtig ist Team-Management relativ zu den anderen Kerntätigkeiten?',
      description_html:
        'Beispiel: Die Stelle beinhaltet Team-Management und Lead Generierung, welche beide gleich wichtig sind, <br />' +
        '--> Bei beiden 50% auswählen ',
    },
    requiredManagementExperience: {
      label: 'Wie viel Erfahrung sollten Talente beim Team-Management haben?',
      description_html: '',
    },
    leadGenChannels: {
      label: 'Welche Kanäle werden genutzt, um Leads zu generieren?',
      description_html: '',
    },
    leadGenGoals: {
      label:
        'Welche Ziele sollen innerhalb der Lead Generierung erfüllt werden?',
      description_html: '',
    },
    consultationLevel: {
      label:
        'Wie hoch ist das Level an Kundenberatung, das benötigt wird um Leads zu konvertieren?',
      description_html:
        '<ul>' +
        '<li> 1: Kunden wissen ohne jegliche Beratung, was am besten für sie geignet ist' +
        '<li> 10: Zur Identifizierung der Probleme und den passenden Lösungen ist tiefgehende Beratung notwendig' +
        '</ul>',
    },
    involvedNegotiation: {
      label:
        'Wie viel eigener Verhandlungsspielraum ist bei der Konvertierung üblich?',
      description_html:
        '<ul><li> 1: Der Leistungsumfang und Konditionen sind komplett gegeben z.B. Produkte im Einzelhandel\n' +
        '<li> 10: Der Leistungsumfang und Konditionen werden immer komplett neu verhandelt z.B. Unternehmensberatungs-Projekte</ul>',
    },
    requiredYearsOfLeadershipExperience: {
      label: 'Erforderliche Erfahrung in Teamleitung',
      description_html: '',
    },
    managedAreas: {
      label: 'Welche Teams oder Abteilungen sollen geleitet werden?',
      description_html: '',
    },
    managementTopics: {
      label: 'Welche Management-Themen sind Teil der Stelle?',
      description_html: '',
    },
    managementTeamsize: {
      label: 'Wie groß ist das Team, das geleitet werden soll?',
      description_html: 'Ohne den/ die neuen Mitarbeiter',
    },
    currentTitles: {
      label:
        'Nenne bitte mindestens 2 Positionen (Job-Titel) oder Unternehmen, aus denen Talente kommen, die für euch ideal sind',
      description_html:
        'Mit diesen Angaben kann unser Talent-Team noch genauer bestimmen, welche Talente für dich geeignet sind ',
      placeholder: 'SDR, BDR, Promo-Agent, Werkstudent',
    },
    leadWarmth: {
      label:
        'Wird in der Stelle eher mit Inbound- oder Outbound-Leads gearbeitet?',
      description_html:
        '<ul>' +
        '<li> Inbound: Leads kommen ohne Einwirken des Mitarbeiters herein (z.B. über Marketing oder andere Team-Mitglieder)' +
        '<li> Outbound: Leads werden aktiv durch den Mitarbeiter generiert (z.B. über Cold Calls oder Linkedin/Xing)' +
        '</ul>',
    },
    vertriebsArt: {
      label: 'Wird eher im Innen- oder Außendienst gearbeitet?',
      description_html:
        '<ul>' +
        '<li> Innendienst: Die Tätigkeiten werden aus dem Büro heraus erfüllt, ohne dass Kunden (häufig) besucht werden' +
        '<li> Außendienst: Der Verkauf findet größtenteils bei den Kunden vor Ort statt' +
        '</ul>',
    },
    descriptionOfSalesProcess: {
      label:
        'Bitte liste mindestens 3-5 Aufgaben & den Inhalt des Jobs in detaillierten Stichpunkten auf.',
      description_html: '',
      placeholder:
        '- Als erste und wichtigste Kontaktperson sorgst Du dafür, dass unsere Sales-Talente optimal mit HYRE starten können\n' +
        '- In Telefonaten entscheidest Du, ob Talente für unseren Talent-Pool geeignet sind\n' +
        '- Lerne unsere Talente besser kennen und betreue sie auf ihrem Weg in eine erfolgreiche Sales-Karriere\n' +
        '- Als Bindeglied zwischen Talenten und Kunden sorgst Du gemeinsam mit unserem Customer-Success Team, durch die richtige Kommunikation jederzeit für ein optimales Erlebnis der Talente\n' +
        '- Parallel nutzt Du Deine Erfahrungen proaktiv, um Strategien und Tools zu entwickeln, die unsere Prozesse immer talentfreundlicher effektiver und skallierbarer machen',
    },
    soldProductWeighting: {
      label:
        'Wie sehr sollen wir deine Angaben bei den nachfolgenden Fragen zu dem verkauften Produkt in unserem Algorithmus gewichten?',
      description_html:
        'Umso höher deine Angabe, desto mehr werden die Angaben relativ zu den anderen Bereichen gewichtet',
    },
    soldProduct: {
      label: 'Was für ein Art von Produkt wird in der Stelle verkauft?',
      description_html: '',
    },
    dealSize: {
      label:
        'Welche Dealgröße haben die verkauften Produkte/ Dienstleistungen durchschnittlich?',
      description_html:
        '<ul>\n' +
        '<li> Abonnements entsprechend dem jährlichen Betrag\n' +
        '<li> Bei Produkten bitte den Einzelpreis ansetzen\n' +
        '</ul>',
    },
    sellingToWhoWeighting: {
      label:
        'Wie sehr sollen wir deine Angaben bei den nachfolgenden Fragen zu den Kunden/ den Firmen an die verkauft wird, in unserem Algorithmus gewichten?',
      description_html:
        'Umso höher deine Angabe, desto mehr werden die Angaben relativ zu den anderen Bereichen gewichtet',
    },
    customerType: {
      label:
        'Bitte teile uns mit, an welche Kundenart primär verkauft werden soll.',
      description_html: '',
    },
    clientIndustries: {
      label: 'In welchen Industrien sind typische Kunden aktiv?',
      description_html: '',
    },
    icp: {
      label:
        'Bitte beschreibe mit mindestens 3 Bullet-points euren ICP (ideales Kunden-Profil).',
      description_html:
        'Z.B. weitere Details zu der Art von Privatperson/ Firma an die verkauft wird oder die genaue Rolle, die ihre Käufer innerhalb der Zielunternehmen haben.',
      placeholder:
        '- Junge ambitionierte Berufseinsteiger, die ins Sales einsteigen wollen\n' +
        '- ODER aktuelle Sales-Profis, die den nächsten Karriereschritte machen wollen',
    },
    germanLevel: {
      label: 'Welches Deutsch Level ist erforderlich?',
      description_html: '',
    },
    englishLevel: {
      label: 'Welches Englisch Level ist erforderlich?',
      description_html: '',
    },
    otherLanguages: {
      label:
        'Welche weiteren Sprachen sind erforderlich, un mit welchem Niveau?',
      description_html: '',
      placeholder:
        'Weitere Sprachen von Vorteil, aber in keinerweise entscheidend ',
    },
    requiredPersonality: {
      label:
        'Beschreibe mindestens 3-5 persönliche Eigenschaften oder Werte, die für deine Firma und die bestimmte Rolle am besten geeignet sind.',
      description_html:
        'Geh dafür z.B. darauf ein welche Ziele der neue Mitarbeiter im Idealfall verfolgen soll oder ob im Team eine gewisse Ellbogenmentalität hilfreich ist.',
      placeholder:
        '- Kommunikationsstärke\n' +
        '- Offene und motivierte Arbeitsweise\n' +
        '- Freude darin, mit unseren Talenten telefonisch Kontakt zu knüpfen und diese kontinuirlich auf ihrem Weg zu begleiten und zu unterstützen \n' +
        '- Eine strukturierte und schnelle Arbeitsweise, die Dir, bei konstant hoher Aufmerksamkeit für Details, erlaubt, parallele Bewerbungsprozesse zu steuern',
    },
    otherRequirements: {
      label:
        'Liste in detaillierten Stichpunkten weitere Erfahrungen und Fähigkeiten auf, die für den Job benötigt werden. Gib bitte klare Angaben zum erforderlichen Kenntnisslevel an und zeige, wo es sich um Must-Haves, und wo um Nice-to-haves handelt.',
      description_html:
        'Z.B. Reisebereitschaft, einen Führerschein, bestimmte akademische Abschlüsse',
      placeholder:
        '- Die Bereitschaft, kreative Wege zu finden und zu gehen, um bestehende Prozesse zu hinterfragen und immer weiter zu optimieren\n',
    },
    mustHaveCriteria: {
      label:
        'Bitte nenne uns alle Kriterien, die gegeben sein MÜSSEN, damit Bewerbungen für dich relevant sind',
      description_html:
        'Bitte wähl nur absolute Must-Haves aus, den mit jeder Auswahl schränkst du dein Matches stark ein.<br />Beispiel:<br />' +
        '- Falls Erfahrung beim Verkauf von SaaS Produkten für dich essentiell ist, dann wähl Verkaufte Produktart aus (geh zudem sicher, dass du bei der Frage zu verkauften Produkten SaaS ausgewählt hast) ',
    },
    opennessToOtherTalents: {
      label:
        'Wie wichtig ist der Match der Kriterien, die keine Must-Haves sind auf einer Skala von 1-10?',
      description_html:
        '<ul>\n' +
        '<li> 1: Alle Talente, unabhängig ihrer Profilüberschneidung mit meiner Position, sollen matchen\n' +
        '<li> 10: Die Überschneidung zwischen Talent-Profil und meiner Position soll idealerweise bei 100 % liegen\n' +
        '</ul>',
    },
    interviewRoundsCount: {
      label:
        'Wie viele Interviewrunden sind normalerweise Teil des Interviewprozesses?',
      description_html: '',
    },
    firstInterviewDescription: {
      label: 'Beschreibe bitte die erste Interviewrunde.',
      description_html:
        'Insbesondere bezüglich des verwendeten Formats (Telefon/Zoom/persönliches Treffen), was beleuchtet wird, und wer aus deinem Unternehmen daran teilnimmt.',
      placeholder: '',
    },
    secondInterviewDescription: {
      label: 'Beschreibe bitte die zweite Interviewrunde.',
      description_html:
        'Insbesondere bezüglich des verwendeten Formats (Telefon/Zoom/persönliches Treffen), was beleuchtet wird, und wer aus deinem Unternehmen daran teilnimmt.',
      placeholder: '',
    },
    thirdInterviewDescription: {
      label: 'Beschreibe bitte die dritte Interviewrunde.',
      description_html:
        'Insbesondere bezüglich des verwendeten Formats (Telefon/Zoom/persönliches Treffen), was beleuchtet wird, und wer aus deinem Unternehmen daran teilnimmt.',
      placeholder: '',
    },
    fourthInterviewDescription: {
      label: 'Beschreibe bitte die vierte Interviewrunde.',
      description_html:
        'Insbesondere bezüglich des verwendeten Formats (Telefon/Zoom/persönliches Treffen), was beleuchtet wird, und wer aus deinem Unternehmen daran teilnimmt.',
      placeholder: '',
    },
    fifthInterviewDescription: {
      label: 'Beschreibe bitte die fünfte Interviewrunde.',
      description_html:
        'Insbesondere bezüglich des verwendeten Formats (Telefon/Zoom/persönliches Treffen), was beleuchtet wird, und wer aus deinem Unternehmen daran teilnimmt.',
      placeholder: '',
    },
    interviewProcessComments: {
      label:
        'Gibt es weitere Besonderheiten im Interviewprozess, die wir kennen sollten, um dich bestmöglich darin zu unterstützen?',
      description_html: '',
      placeholder: '',
    },
    contactPerson: {
      label: 'Wie lautet dein Vorname?',
      description_html: '',
    },
    contactPersonLastName: {
      label: 'Wie lautet dein Nachname?',
      description_html: '',
    },
    contactPersonEmail: {
      label: 'Unter welcher E-mail erreichen wir dich?',
      description_html:
        'Falls du die E-mail Adresse ändern möchtest, sag uns bitte Bescheid.',
    },
    contactPersonPhone: {
      label: 'Unter welcher Telefonnummer können wir dich erreichen?',
      description_html: '',
    },
    contactPersonMeetingUrl: {
      label:
        'Wenn du möchtest, kannst du uns einen Link zu deinem Online-Kalender (z.B. Calendly oder Hubspot) geben, damit wir dir die Terminkoordinierung mit unseren Talenten abnehmen können.',
      description_html: '',
    },
    contactPersonPositionTitle: {
      label: 'Welche Position hältst du innerhalb von deinem Unternehmen?',
      description_html: '',
    },
    fullyRemote: {
      label: 'Ist die Stelle vollständig remote?',
      description_html: '',
    },
    timezone: {
      label: 'Gibt es eine bevorzugte Zeitzone für diese Position?',
      description_html: 'z.B. GMT +/- 3',
    },
    requiredDegree: {
      label: 'Erforderlicher akademischer Werdegang',
      description_html: '',
    },
    requiredManagedTeamSize: {
      label: 'Teamgröße, die bereits geleitet wurde',
      description_html: '',
    },
    requiredGermanLevel: {
      label: 'Erforderliches Deutsch Level',
      description_html: '',
    },
    requiredEnglishLevel: {
      label: 'Erforderliches Englisch Level',
      description_html: '',
    },
    requiredOtherLanguages: {
      label: 'Welche andere Sprachen sind erforderlich?',
      description_html: '',
    },
    requiredColdCallingExperience: {
      label: 'Erforderliche Erfahrung im Cold Calling',
      description_html: '',
    },
    requiredPromotionExperience: {
      label: 'Erforderliche Erfahrung im Promotion oder Ähnlichem',
      description_html: '',
    },
    requiredSaasB2BClosingExperience: {
      label: 'Erforderliche Erfahrung im SaaS B2B Closing',
      description_html: '',
    },
    requiredNonSaasB2BClosingExperience: {
      label: 'Erforderliche Erfahrung im Non-SaaS B2B Closing',
      description_html: '',
    },
    requiredNonSaasB2CClosingExperience: {
      label: 'Erforderliche Erfahrung im Non-SaaS B2C Closing',
      description_html: '',
    },
    requiredSaasB2BAccountManagementExperience: {
      label: 'Erforderliche Erfahrung im SaaS B2B Account Management',
      description_html: '',
    },
    requiredNonSaasB2BAccountManagementExperience: {
      label: 'Erforderliche Erfahrung im Non-SaaS B2B Account Management',
      description_html: '',
    },
    requiredNonSaasB2CAccountManagementExperience: {
      label: 'Erforderliche Erfahrung im Non-SaaS B2C Account Management',
      description_html: '',
    },
    requiredLeadershipExperience: {
      label: 'Abteilungen, die bereits geleitet wurden',
      description_html: '',
    },

    workationDetails: {
      label: 'Workation',
      description_html:
        'Falls Workation Teil eurer Policy ist, bitte hier weitere Infos dazu angeben.',
    },
  },
  submit: {
    cta: 'Jobstelle vervollständigen',
  },
}
export default {
  profileSetup,
  positionSetup,
}
